module.exports = __webpack_public_path__ + "img/introducePageFive_show_one.e3a1b8d8.jpg";